import {Component, Input} from '@angular/core';
import {Documento} from '../../shared/model/documentos.model';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-documento',
  imports: [CommonModule],
  templateUrl: './documento.component.html',
  styleUrl: './documento.component.css'
})
export class DocumentoComponent {
  @Input() documento: Documento[] = [];

  formatarDataHora(data: Date | string): string {
    return data ? new Date(data).toLocaleString('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short'
    })
    .replace(',', ' -'): '';

  }

  getPrimeiroUltimoNome(nomeCompleto: string): string {
    if (!nomeCompleto || nomeCompleto.trim().length === 0) {
      return '';
    }

    const nomes = nomeCompleto.trim().split(' ');

    if (nomes.length === 1) {
      return nomes[0];
    }

    const primeiroNome = nomes[0];
    const ultimoNome = nomes[nomes.length - 1];

    return `${primeiroNome} ${ultimoNome}`;
  }
}
